import { Box } from '@mui/material';
import React, { useState } from 'react';
import { IContact } from '../../../generated/graphql';
import CustomAppBar from '../../Common/Layout/CustomAppBar';
import PaperCard from '../../Common/Layout/PaperCard';
import TabPanel from '../../Common/Layout/TabPanel';
import ContactAssistantTab from './ContactAssistantTab';
import ContactGeneralTab from './ContactGeneralTab';
import ContactInterestsTab from './ContactInterestsTab';
import ContactOfficeTab from './ContactOfficeTab';
import ContactMeetingsTab from './ContactMeetingsTab';

interface IProps {
  contact: IContact;
}

const ContactDetailsTabs: React.FunctionComponent<IProps> = ({ contact }) => {
  const [value, setValue] = useState(0);

  const handleChange = (_: unknown, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box className="centralize" sx={{ width: '100%', paddingTop: '80px' }}>
      <PaperCard width="82%" additionalStyle={{ height: '680px' }}>
        <CustomAppBar
          type="third"
          value={value}
          handleChange={handleChange}
          tabProps={[
            {
              id: 'contact-general-tab',
              title: 'General'
            },
            {
              id: 'contact-office-tab',
              title: 'Office'
            },
            {
              id: 'contact-interests-tab',
              title: 'Interests'
            },
            {
              id: 'contact-assistant-tab',
              title: 'Assistant'
            },
            {
              id: 'contact-meetings-tab',
              title: 'Meetings'
            }
          ]}
        />
        <TabPanel value={value} index={0}>
          <ContactGeneralTab contact={contact} />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <ContactOfficeTab contact={contact} />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <ContactInterestsTab id={contact.id} />
        </TabPanel>
        <TabPanel value={value} index={3}>
          <ContactAssistantTab contact={contact} />
        </TabPanel>
        <TabPanel value={value} index={4}>
          <ContactMeetingsTab contact={contact} />
        </TabPanel>
      </PaperCard>
    </Box>
  );
};

export default ContactDetailsTabs;
